import {handleActions} from 'redux-actions';
import humanizeDuration from 'humanize-duration';
import humanizeString from 'humanize-string';
import {INGEST_CONFIGS_SET} from './IngestConfigsActions';
import {formatProviderName} from '../../IngestList/Redux/IngestListReducer';
import {
    IngestConfigPayloadItem,
    IngestConfigState,
    ContentPartnerPayload,
} from './IngestConfigsReducerTypes';

export const mapSecondsToMilliseconds = (value: number) => value * 1000;

export const formatPolling = ({timeoutType, timeout}: IngestConfigPayloadItem) => {
    if (!timeoutType) return;

    if (timeoutType.toUpperCase() === 'DAILY')
        return humanizeString(`${timeoutType} at ${timeout}`);

    if (timeoutType.toUpperCase() === 'EVERY') {
        const [time] = timeout.map(mapSecondsToMilliseconds);

        const humanTime = humanizeDuration(time, {
            units: ['m'],
        }).toUpperCase();
        return humanizeString(`${timeoutType} ${humanTime}`);
    }

    return timeoutType;
};

export const getPartnerName = ({contentPartner}: IngestConfigPayloadItem) => {
    if (!contentPartner) return;

    return contentPartner.partnerName;
};

export const mapRows = (row: IngestConfigPayloadItem) => ({
    ...row,
    provider: formatProviderName(row),
    polling: formatPolling(row),
    contentPartner: getPartnerName(row),
});

export const setIngestConfigs = (
    state: IngestConfigState,
    {payload}: ContentPartnerPayload
) => {
    const {rows, total} = payload;

    if (rows)
        return {
            rows: rows.map(mapRows),
            total,
        };

    return state;
};

export const initialState = {
    rows: [],
    total: 0,
};

const handlers = {
    [INGEST_CONFIGS_SET]: setIngestConfigs,
};

export default handleActions(handlers, initialState);
